// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-row-mobile{background-color:#fff}@media screen and (min-width:960px){.header-row-mobile{height:150px}}@media screen and (max-width:960px){.header-row-mobile{background-color:#fff;border:1px solid #eaeaea!important;box-shadow:0 2px 2px 0 rgba(0,0,0,.04)!important;position:relative;width:100vw}.header-row-mobile .back-button-mobile{border:none;box-shadow:none!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
